export default {"src":"/_next/static/media/loader.3b108754.gif","height":572,"width":1017};